export const FETCHING_PARTNER = 'FETCHING_PARTNER';
export const FETCHING_ETABLISSEMENT = 'FETCHING_ETABLISSEMENT';
export const FETCHING_ANTICIPA = 'FETCHING_ANTICIPA';
export const FETCHING_FACILITA = 'FETCHING_FACILITA';
export const FETCHING_SERENITA = 'FETCHING_SERENITA';
export const FETCHING_USERS = 'FETCHING_USERS';
export const CREATING_USER = 'CREATING_USER';
export const FETCHING_ETABLISSEMENT_LIST = 'FETCHING_ETABLISSEMENT_LIST';